export default {
  dragAndDropYourFilesHereOr: "Ziehen Sie die Dateien hierher",
  uploadFiles: "Datei auswählen",
};
